import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private oidcSecurityService: OidcSecurityService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    // Excluir URLs que no deben llevar token (presigned, estáticos, etc.)
    const isExternal = !req.url.startsWith(environment.urlCore);
    const isPresigned = req.url.includes('amazonaws.com') || req.url.includes('presignedUrl');

    if (isExternal || isPresigned) {
      return next.handle(req);
    }

    // Si la seguridad está desactivada (modo local)
    if (!environment.securityEnabled) {
      const fakeToken = 'fake-local-token';
      const cloned = req.clone({
        setHeaders: { Authorization: `Bearer ${fakeToken}` },
      });
      return next.handle(cloned);
    }

    // Si la seguridad está activada
    return from(this.oidcSecurityService.getAccessToken()).pipe(
      switchMap((token) => {
        if (token) {
          const cloned = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
          return next.handle(cloned);
        }
        return next.handle(req);
      })
    );
  }
}
